export const screenerCopyEs = {
    start: "Empezar",
    starting: "Iniciando...",
    checking: "Comprobando sus respuestas...",
    notFoundTitle: "Este enlace no funciona",
    notFoundBody: "Es posible que el cuestionario esté cerrado. Hable con el equipo que le dio este enlace.",
    eligibleTitle: "Puede participar",
    eligibleBody: "Cree su cuenta para empezar.",
    ineligibleTitle: "Este programa no es adecuado para usted",
    ineligibleBody:
        "Gracias por responder. Según sus respuestas, no cumple los criterios. Si tiene preguntas, hable con el equipo que le dio este enlace.",
    continueToSignUp: "Continuar al registro",
    scanOnPhone: "O escanee este código con la cámara de su teléfono para registrarse en el teléfono.",
    startAgain: "Empezar de nuevo",
};
